import { CHATBOT_COMMANDS } from '~/utils/chat-flags';
import { getDepositWithdrawal } from '~/api/withdrawals';
import { humanizeTimestamp } from '~/utils/date-helper';

export default {
  methods: {
    /**
     * Checks withdrawal status
     * @command - '[apicall] checkWithdrawalStatus [/apicall]'
     * @param {object} currentTrx - currently selected transaction object
     */
    async checkWithdrawalStatus(currentTrx) {
      if (!currentTrx) {
        this.$zopim.sendChatMsg(CHATBOT_COMMANDS.responses.noSelectedTransaction);
        return;
      }

      const responses = {
        withdrawalStatus: '[apiresponse] withdrawalStatus<state> [/apiresponse]',
        checkWithdrawalStatusError: '[apiresponse] WithdrawalStatusError [/apiresponse]',
      };

      try {
        const { data: withdrawalData } = await getDepositWithdrawal(this.$axios, currentTrx.detailId);
        const { state } = withdrawalData;
        const capitalizedState = state.charAt(0).toUpperCase() + state.slice(1);
        const finalResponse = responses.withdrawalStatus.replace('<state>', capitalizedState);
        this.$zopim.sendChatMsg(finalResponse);
      } catch (error) {
        this.$zopim.sendChatMsg(responses.checkWithdrawalStatusError);
        console.error('[ERROR] Something is wrong when trying to check user withdrawal status', error);
      }
    },

    /**
     * Checks withdrawal SLA
     * @command - '[apicall] checkWithdrawalSLA [/apicall]'
     * @param {object} currentTrx - currently selected transaction object
     */
    async checkWithdrawalSLA(currentTrx) {
      if (!currentTrx) {
        this.$zopim.sendChatMsg(CHATBOT_COMMANDS.responses.noSelectedTransaction);
        return;
      }

      const responses = {
        withdrawalWithinSLA: '[apiresponse] withdrawalWithinSLA [/apiresponse]',
        withdrawalOutsideSLA: '[apiresponse] withdrawalOutsideSLA [/apiresponse]',
        checkWithdrawalSLAError: '[apiresponse] checkWithdrawalSLAError [/apiresponse]',
      };

      try {
        const { data: withdrawalData } = await getDepositWithdrawal(this.$axios, currentTrx.detailId);
        const createdAt = new Date(withdrawalData.created_at);
        const dateNow = new Date();
        const oneDay = 24 * 60 * 60 * 1000;

        if (dateNow - createdAt >= oneDay) {
          this.$zopim.sendChatMsg(responses.withdrawalOutsideSLA);
          return;
        }
        const waitDate = createdAt.setDate(createdAt.getDate() + 1);

        this.sendMessage({
          msg: `Coba tunggu sampai ${humanizeTimestamp(waitDate, '%dd% %month% %yyyy% jam %hh%:%mi%')} WIB, ya!`,
          nick: 'agent:trigger', // impersonate Acha Bot
          displayName: 'Acha',
        });
        this.$zopim.sendChatMsg(responses.withdrawalWithinSLA);
      } catch (error) {
        this.$zopim.sendChatMsg(responses.checkWithdrawalSLAError);
        console.error('[ERROR] Something is wrong when trying to check user withdrawal status', error);
      }
    },
  },
};
